import type { ReactNode } from 'react';
import type { JobState } from '../tokens/tokens';
import './StatusDot.css';

export type StatusTone = 'neutral' | 'success' | 'warning' | 'danger' | 'accent';

export interface StatusDotProps {
  /** Either a job state or a generic tone. */
  state?: JobState;
  tone?: StatusTone;
  /** A pulse marks live activity; it stops under prefers-reduced-motion. */
  live?: boolean;
  /** Screen-reader text; sighted users get the colour, everyone gets the word. */
  label: string;
  size?: 'sm' | 'md';
}

export function StatusDot({
  state,
  tone = 'neutral',
  live,
  label,
  size = 'md',
}: StatusDotProps): ReactNode {
  const colour = state ? `pui-dot--state-${state}` : `pui-dot--${tone}`;
  const classes = ['pui-dot', colour, `pui-dot--${size}`, live && 'pui-dot--live']
    .filter(Boolean)
    .join(' ');
  return (
    <span className={classes} role="img" aria-label={label}>
      <span className="pui-visually-hidden">{label}</span>
    </span>
  );
}
